export default {
  paged: {
    select: 'id,status,type,number,start,end,reason,',
    searchSelect: ['reason', 'number'],
    expand: {
      sourceUser: { select: 'fullName' },
    },
  },
  item: {
    select:
      'id,status,type,number,start,end,reason,sourceUserId,delegatePendingTasks,keepSourceUserAsApproval,removeDelegatedTasksAtTheEnd',
    expand: {
      sourceUser: { select: 'id,fullName' },
    },
  },
  itemDetail: {
    select:
      'id,status,type,number,start,end,reason,sourceUserId,keepSourceUserAsApproval,removeDelegatedTasksAtTheEnd,delegatePendingTasks,created,updated,creator,voidedReason,voidedDate',
    expand: {
      sourceUser: { select: 'fullName' },
      userModifier: { select: 'fullName' },
      voidedUser: { select: 'fullName' },
    },
  },
};
